import React from "react"
import cx from "classnames"
import classes from "./styles.module.scss"

export const SingleColumn = ({children}) => {
  return <div className={cx(classes.SingleColumn)}>{children}</div>
}
export default SingleColumn
